export const OltMobileActionBtn = ({ icon: Icon, label, onClick, color }) => (
    <button
      type="button"
      onClick={onClick}
      className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200 cursor-pointer`}
      style={{ background: `${color}15`, border: `1px solid ${color}25` }}
      onMouseEnter={(e) => { e.currentTarget.style.background = `${color}25`; }}
      onMouseLeave={(e) => { e.currentTarget.style.background = `${color}15`; }}
      aria-label={label}
    >
      <Icon className="text-sm" style={{ color }} />
    </button>
  );
  